"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FarmerWrapper = void 0;
const tslib_1 = require("tslib");
const token_utils_1 = require("@saberhq/token-utils");
const spl_token_1 = require("@solana/spl-token");
const web3_js_1 = require("@solana/web3.js");
class FarmerWrapper {
    /**
     *
     * @param plot
     * @param authority
     * @param farmerKey
     * @param tokenVaultKey (associated w/ farmerKey)
     * @param stakedTokenATA Staked token ATA (associated w/ authority)
     */
    constructor(plot, authority, farmerKey, tokenVaultKey, stakedTokenATA) {
        this.plot = plot;
        this.authority = authority;
        this.farmerKey = farmerKey;
        this.tokenVaultKey = tokenVaultKey;
        this.stakedTokenATA = stakedTokenATA;
    }
    /**
     * The program.
     */
    get program() {
        return this.plot.program;
    }
    /**
     * The Saber SDK.
     */
    get saber() {
        return this.plot.saber;
    }
    /**
     * Creates the farmer of the provided wallet.
     */
    initialize() {
        const instruction = this.program.instruction.createFarmer({
            accounts: {
                authority: this.authority,
                farmer: this.farmerKey,
                plot: this.plot.key,
                rent: web3_js_1.SYSVAR_RENT_PUBKEY,
                systemProgram: web3_js_1.SystemProgram.programId,
                payer: this.program.provider.wallet.publicKey,
                farmerVault: this.tokenVaultKey,
                tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
                associatedTokenProgram: spl_token_1.ASSOCIATED_TOKEN_PROGRAM_ID,
                tokenMint: this.plot.token.mintAccount,
            },
        });
        return {
            farmer: this.farmerKey,
            wrapper: this,
            tx: this.saber.newTx([instruction]),
        };
    }
    /**
     * Generates stake accounts for the user.
     * @returns
     */
    get userStakeAccounts() {
        const authority = this.authority;
        const farmer = this.farmerKey;
        const farmerVault = this.tokenVaultKey;
        return {
            authority,
            farmer,
            plot: this.plot.key,
            tokenAccount: this.stakedTokenATA,
            tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
            landlord: this.plot.plotData.landlordKey,
            clock: web3_js_1.SYSVAR_CLOCK_PUBKEY,
            farmerVault,
        };
    }
    performStakeAction(amount, action) {
        const instruction = this.program.instruction[action](amount.toU64(), {
            accounts: this.userStakeAccounts,
        });
        return this.saber.newTx([instruction]);
    }
    getOrCreateStakedAssociatedTokenAccountInternal() {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function* () {
            return yield (0, token_utils_1.getOrCreateATA)({
                provider: this.plot.saber.provider,
                mint: this.plot.token.mintAccount,
                owner: this.authority,
            });
        });
    }
    /**
     * Creates the ATA of the user's staked token if it doesn't exist.
     */
    createATAIfNotExists() {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function* () {
            const { instruction } = yield this.getOrCreateStakedAssociatedTokenAccountInternal();
            if (!instruction) {
                return null;
            }
            return this.saber.newTx([instruction]);
        });
    }
    /**
     * Stakes the current wallet's tokens into the pool.
     * @param amount
     * @returns
     */
    stake(amount) {
        return this.performStakeAction(amount, "stakeTokens");
    }
    /**
     * Withdraws the current wallet's tokens from the pool.
     * @param amount
     * @returns
     */
    withdraw(amount) {
        return this.performStakeAction(amount, "withdrawTokens");
    }
    /**
     * Fetches the data associated with the farmer.
     * @returns
     */
    fetchData() {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function* () {
            return yield this.program.account.farmer.fetch(this.farmerKey);
        });
    }
    /**
     * Claims an amount of tokens.
     * @returns
     */
    claim() {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function* () {
            const mintProxyStateAddress = this.saber.programs.MintProxy.state.address();
            const mintProxyState = yield this.saber.programs.MintProxy.state.fetch();
            const minterInfo = yield this.saber.programs.MintProxy.account.minterInfo.associatedAddress(this.plot.plotData.landlordKey);
            const instructions = [];
            const { address: rewardsTokenAccount, instruction: ataInstruction } = yield (0, token_utils_1.getOrCreateATA)({
                provider: this.plot.saber.provider,
                mint: this.plot.landlordData.rewardsTokenMint,
                owner: this.authority,
            });
            if (ataInstruction) {
                instructions.push(ataInstruction);
            }
            const ix = this.plot.program.instruction.claimRewards({
                accounts: {
                    proxyMintAuthority: mintProxyState.proxyMintAuthority,
                    mintProxyState: mintProxyStateAddress,
                    mintProxyProgram: this.saber.programs.MintProxy.programId,
                    minterInfo,
                    rewardsTokenMint: this.plot.landlordData.rewardsTokenMint,
                    rewardsTokenAccount,
                    stake: this.userStakeAccounts,
                },
            });
            instructions.push(ix);
            return this.saber.newTx(instructions);
        });
    }
}
exports.FarmerWrapper = FarmerWrapper;
//# sourceMappingURL=farmer.js.map